export const INIT_ENVIROMENT = 'ENVIRONMENT/INIT';
export const VIPPS_REDIRECT_URL_RECEIVED = 'ENVIRONMENT/VIPPS_REDIRECT_URL_RECEIVED';
export const VIPPS_REDIRECT_URL_REQUESTED = 'ENVIRONMENT/VIPPS_REDIRECT_URL_REQUESTED';
